function createUniqueId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return prefix + Math.random().toString(36).substr(2, 6) + new Date().getTime().toString().substr(2, 3) + suffix;
}

export { createUniqueId as default };
//# sourceMappingURL=id.js.map
